import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultWordInfo } from '../interfaces/WordIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C401WordGetProps {
  execWordGet: (deviceId: string) => Promise<ResultWordInfo>
  loading: loadStatus
}
// C401 強調単語一覧取得API呼出
export const useC401WordGet = (): C401WordGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execWordGet = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(
        buildDeviceUrl(deviceId, apiUrl.wordsPath),
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execWordGet, loading }
}
